import * as React from "react";
const SvgDeviceChassis = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.002 2.814c-5.68-.001-7.108 0-7.111.01L3.379 7.36 1.87 11.881V21.187H22.13V11.881L20.617 7.35l-1.51-4.532ZM7.186 4.312h4.816l6.021.002 1.3 3.899a320.883 320.883 0 0 1 1.298 3.933v.036H3.38v-.036c0-.022.497-1.522 1.297-3.923l1.3-3.9c.002-.006.305-.01 1.21-.01ZM3.379 13.69H20.62v6H3.38v-3zM12 15.936V17.443l3.281-.002 3.281-.002.002-.752.002-.752h-3.283z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgDeviceChassis;
